import { connect } from 'react-redux';
import { actions } from './reducer';
import StoryGroupPopover from './components/StoryGroupPopover';

export default connect(
  () => {
    return {};
  },
  (dispatch) => ({
    onDropCard: (cardSource, cardTarget, end = false) => {
      if (end) {
        dispatch(actions.trackDroppedCard(cardSource, cardTarget));
      } else {
        dispatch(actions.onDropCard(cardSource, cardTarget));
      }
    },
    onDeleteStory: (storyCard) => {
      dispatch(actions.deleteStory(storyCard));
    },
  })
)(StoryGroupPopover);

export { default as reducer, actions, actionTypes } from './reducer';
export { default as middleware } from './middleware';
